import { StudentTableRows } from '../models/student-table-rows.model';
import { DeletedStudent } from '../models/undeleter.model';

//-- support state will track all support action in case of page navigation away to recover existing entries

export interface AccountTransferIDs {
  fromAccount: TransferinatorAccountDetails;
  toAccount: TransferinatorAccountDetails;
}
export interface TransferinatorAccountDetails {
  id: number;
  language: string;
  accountName: string;
}
export interface SupportState {
  studentTransfer: {
    // studentAccountTransferForm: StudentTransferForm;
    studentTableRows: StudentTableRows[];
    cacheStudentTableRows: StudentTableRows[];
    accountIds: AccountTransferIDs;
    error: string;
  };
  cleverSupport: {
    accountId: number;
    loading: boolean;
    result: {
      institutionName: string;
      contactName: string;
      address: string[];
      ssoDistrictName: string;
      ssoReference: string;
      lookupMethod: string;
      isSetUp: boolean;
      isComplete: boolean;
    };
    error: string;
  };
  undeleteSupport: {
    accountId: number;
    loading: boolean;
    result: { students: DeletedStudent[] };
  };
}

export const supportInitialState: SupportState = {
  studentTransfer: {
    accountIds: {
      fromAccount: { language: '', accountName: '', id: 0 },
      toAccount: { language: '', accountName: '', id: 0 }
    },
    studentTableRows: [],
    cacheStudentTableRows: [],
    error: ''
  },
  cleverSupport: {
    accountId: 0,
    loading: false,
    result: {
      institutionName: '',
      contactName: '',
      address: [],
      ssoDistrictName: '',
      ssoReference: '',
      lookupMethod: '',
      isSetUp: false,
      isComplete: false
    },
    error: ''
  },
  undeleteSupport: {
    accountId: 0,
    loading: false,
    result: {} as { students: DeletedStudent[] }
  }
};
